import ContactFormTopicPostModel from "@/views/contact-form-topic/models/contact-form-topic-post.model";

export default {
    name: "contact-form-topic-add",
    data() {
        return {
            item: {}
        }
    },
    computed: {
        isEditPage() {
            return this.$route.meta.edit;
        },
    },
    methods: {
        approve() {
            let data = new ContactFormTopicPostModel(this.item);
            if (this.isEditPage) {
                this.$store.dispatch("contactFormTopic/updateItem", {id: data.id, data: data});
            } else {
                this.$store.dispatch("contactFormTopic/setItem", data).then((res) => {
                    if (res) {
                        this.item = {};
                    }
                });
            }
        },
    },
    created() {
        let id = this.$route.params.id;
        this.$store.dispatch("contactFormTopic/getItems");
        if (this.isEditPage) {
            this.$store.dispatch("contactFormTopic/getItemById", id).then((res) => {
                if (res) {
                    this.item = res;
                }
            });
        }
    },
};
